import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  logisticsSafety,
  manufacturingAsset,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'LoRa (Low Range Radio) là một trong những công nghệ truyền thông không dây được thiết kế cho giao tiếp không dây tầm xa và tiêu thụ điện năng thấp. Công nghệ này được sử dụng trong nhiều lĩnh vực ứng dụng khác nhau như mạng lưới cảm biến, Smart City, tự động hóa nông nghiệp, tự động hóa công nghiệp, v.v., và đặc biệt phù hợp cho giao tiếp giữa các thiết bị IoT (Internet of Things).',
  keywords: 'LoRa, Công nghệ truyền thông, Cong nghe truyen thong, IoT\n',
  ogSite: 'LoRa là gì?',
  title: 'LoRa là gì?',
  ogUrl: 'https://orbro.io/vi/blog/what-is-LoRA',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDkGw848hiaZwUj1NzOs30j6aqQAJyNCTeY0oQIeVJFOkeYuNI3kvZhnbc5uEfN7j4eLrviv8mEssXZn4lxH-dLhqXgRoLEtW86etie39T8Z4ZrsMxp-5A2G7W4VIP6BP_qFtyqDEJ_krIVKkxluM5vTPOKBMEyrGtQ_3ydm3DGKWHp7F-ShLBeXFtG1oET_EreJ_iYWOkT3CzAatE2_V77uE1qOcaLPuWCttx2d70Jt6u0a7tKI8nKCOheeIgrZqmaGNHLXtWSyJnPPkS083MmuPZv_AuP5JXZOe4h-xyzZcYCyo1E8vbbzRQZKjDcRj4CXwdfV6isxP_GMeoZXMvMMQR6ZL-CjdMHskmTwCTVRtYSQd-QRWtlRXn5bdxpcE5n2kgYENQIRBn73zqANbo6d7dbmHSgh3vqEzNP7yLk6mMQ-YNVO_04A1nNDlqhOaA9HQ7kkUtvDq1WsmkMAw2i169IEUISWz8pliXgKuRnPM_YOP8EWj0ewhPm6YtPrYizD5n9yo8sGI_B1E63PiHKz9hRNeRPSWKrkFPIlT-Y-adJ1giugNEpETW7dZOnr3u_FsbtzrPm6eOw5gQecQrBtDq14AN5olMMyI3_uGibjXoS3rutDYRvls1YlPMHv2iUBWhe9CmRSI9BsT-_tyscLg6cwWAhwfb9OdbWga3TI7dLo9b7s-8SFXm6s6Yqop9WgsB23-rOl_h4UAZHsjRu93uENXiNTD7YD-5VbvdSubD6Ffj3xkL3f9HdhilG3turAnuWLTcQPQ6f9yePOwuvoIrcmXntkKHwzoChR5WH4VoWk83o-UippkYQ3gzYCJJ8-4yd9JZg-TUA3-n9KHJvWyoaCjlaOTCkcBygN_c4WcWJgu3zui6gzBVZTv3oyuKzJzYYslQ89doq9Lh_T7yohz1vbGyDjOJ7gr-onVsc-yfw0_f3apHYvqfZKsSE_9DLZ6G9uzBBotKH-KPTnvEp3OA-2poPSP5Z-DsbLOymfPnvpMPs5ZsiCGh7Jvomyr5pxJcJL19u6HKf3979fiLresgN9QVAef0DmZTEYu76a10CjiW20Ne3C15KDO6Q2ICYOLpVyObPTZc6gGrvgED_Xr2Ul4We1Nc38VxTaLYoPMhzbg8SIe6AZ_UzExO4tZtDfX1hU-5kzIRBq2lXR1cKGXLvP8B0VUshx8iDhwWXOkUPuCyymV8Ng2j6JQyXZr0H2lyhO-b4WgS3aP5efeg_Ny64v_sUBQVG9wKL2FSxalXpQy5LHTrrbPV3akp2a7BeoMondBr7DVQnCTG8sc1oOJb-ZkAtOR05xmrGM2l4A0PlhelYg6RIyPfBvkGI5PV8lh3yPOUQVQCXBzqm_G6LYCRbqWdX5-3BlFEh4-fQpy6luoA1LossKR8VX0DXX8e9lcSJT17c2nXpV9w1mjyWuW8rYGBCeiiyulrgkobyIG_fSCd3TWmdr10IZU-_4msP81pWVBQ0iqdbEp4g-5cuufyYZ-hJo1dOOQGOsizdKKRg_-ndSZc_0nSCjjoEIoxoIl_wZN08371fZ_3FzYFTjFYkbcO9F=w1834-h1208',
  ogType: 'website',
  date: '2024-01-15',
  tag1: '#LoRa',
  tag2: '#Congnghetruyenthong',
  tag3: '#IoT',
  tag4: '#RTLS',
  text: [
    {
      head: 'LoRa là gì?',
      subHead: '',
      desc: 'LoRa (Low Range Radio) là một trong những công nghệ truyền thông không dây được thiết kế cho giao tiếp không dây tầm xa và tiêu thụ điện năng thấp. Công nghệ này được sử dụng trong nhiều lĩnh vực ứng dụng khác nhau như mạng lưới cảm biến, Smart City, tự động hóa nông nghiệp, tự động hóa công nghiệp, v.v., và đặc biệt phù hợp cho giao tiếp giữa các thiết bị IoT (Internet of Things). Công nghệ này tận dụng hiệu quả dải tần số, cung cấp khoảng cách giao tiếp lên đến vài chục kilomet, đồng thời kéo dài tuổi thọ pin nhờ mức tiêu thụ điện năng thấp. Ngoài ra, với đặc điểm hiệu quả về chi phí và tính bảo mật, nó được ứng dụng trong nhiều lĩnh vực đa dạng.',
      dot: '',
    },
    {
      head: 'Đặc điểm của LoRa',
      subHead: 'Giao tiếp Tầm xa',
      desc: 'LoRa hỗ trợ giao tiếp tầm xa, cung cấp khoảng cách giao tiếp lên đến vài chục kilomet. Điều này đặc biệt hữu ích khi thu thập hoặc giám sát dữ liệu cảm biến ở các khu vực nông nghiệp hoặc vùng sâu vùng xa.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tiêu thụ Điện năng thấp',
      desc: 'LoRa có đặc điểm là giao tiếp tiêu thụ điện năng thấp, cho phép hoạt động trong thời gian dài trên các thiết bị tiêu thụ điện năng thấp như các thiết bị cảm biến chạy bằng pin. Điều này giúp các nút trong mạng lưới cảm biến ít cần thay pin hoặc sạc hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Sử dụng Dải tần số',
      desc: 'LoRa chủ yếu sử dụng dải tần ISM (Industrial, Scientific, Medical) như 868MHz (châu Âu), 915MHz (Mỹ). Dải tần số này có thể sử dụng miễn phí và có các đặc tính phù hợp cho các thiết bị tiêu thụ điện năng thấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Chi phí thấp',
      desc: 'LoRa có thể được triển khai với chi phí tương đối thấp. Điều này giúp nó được sử dụng hiệu quả về mặt chi phí ngay cả khi triển khai số lượng lớn thiết bị IoT.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cấu trúc Mạng hình Sao (Star Topology)',
      desc: 'Mạng LoRa chủ yếu sử dụng cấu trúc mạng hình sao (Star Topology), trong đó mỗi thiết bị giao tiếp trực tiếp với Gateway. Điều này giúp việc mở rộng mạng lưới dễ dàng và giao tiếp giữa các thiết bị diễn ra nhanh chóng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Khả năng mở rộng và Linh hoạt',
      desc: 'LoRa có thể được áp dụng một cách linh hoạt cho nhiều lĩnh vực ứng dụng khác nhau. Ngoài ra, nó có đặc tính cho phép dễ dàng thêm các thiết bị mới vào mạng lưới để mở rộng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Mã hóa và Bảo mật',
      desc: 'LoRa cung cấp mã hóa trong quá trình truyền dữ liệu để tăng cường bảo mật. Điều này đảm bảo việc truyền dữ liệu cảm biến quan trọng một cách an toàn. Ngoài ra, vì công nghệ LoRa được phát triển như một tiêu chuẩn mở, nhiều nhà sản xuất có thể cung cấp các thiết bị tương thích.',
      dot: '',
    },
    {
      head: 'Các trường hợp sử dụng LoRa',
      subHead: 'Tự động hóa Nông nghiệp',
      desc: 'LoRa được sử dụng trong lĩnh vực nông nghiệp để xây dựng mạng lưới cảm biến, thu thập và phân tích dữ liệu như tình trạng cây trồng, điều kiện đất đai theo thời gian thực, từ đó nâng cao năng suất nông nghiệp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Smart City',
      desc: 'LoRa cung cấp giao tiếp hiệu quả giữa các cảm biến và thiết bị đa dạng trong Smart City, được áp dụng trong quản lý hạ tầng đô thị, giám sát môi trường, hệ thống an toàn công cộng, v.v., thúc đẩy sự phát triển của Smart City.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa Công nghiệp',
      desc: 'LoRa hỗ trợ giao tiếp giữa các cảm biến và thiết bị trong lĩnh vực tự động hóa công nghiệp, được sử dụng để tối ưu hóa và giám sát quy trình sản xuất. Điều này giúp nâng cao hiệu quả sản xuất và cắt giảm chi phí.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giám sát Môi trường',
      desc: 'LoRa được áp dụng trong giám sát môi trường tự nhiên để thu thập dữ liệu như chất lượng không khí, chất lượng nước, khí hậu theo thời gian thực, từ đó giám sát sự thay đổi của môi trường và đưa ra các biện pháp ứng phó.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quản lý Tòa nhà thông minh',
      desc: 'LoRa được sử dụng để quản lý hiệu quả việc sử dụng năng lượng, hệ thống an ninh, kiểm soát hệ thống sưởi/làm mát, v.v., thông qua giao tiếp với các hệ thống khác nhau trong tòa nhà, góp phần xây dựng các tòa nhà thông minh.',
      dot: '',
    },
    {
      head: 'Triển vọng tương lai của Công nghệ LoRa',
      subHead: 'Chuẩn hóa Dữ liệu và Mở rộng quy mô',
      desc: 'Thông qua những nỗ lực chuẩn hóa dữ liệu và mở rộng quy mô của LoRa, khả năng tương tác giữa các nhà sản xuất và nhà cung cấp dịch vụ khác nhau được dự đoán sẽ được cải thiện. Điều này sẽ mở rộng hơn nữa hệ sinh thái sử dụng LoRa và tăng cường vị thế của nó trên thị trường IoT toàn cầu.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Kết hợp với Edge Computing',
      desc: 'LoRa được dự đoán sẽ kết hợp với Edge Computing để hỗ trợ xử lý dữ liệu theo thời gian thực và chạy các ứng dụng, từ đó cung cấp mức độ tự động hóa và thông minh hóa cao hơn cho các thiết bị và hệ thống thông minh.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường Bảo mật',
      desc: 'LoRa được kỳ vọng sẽ phát triển các tính năng mạnh mẽ hơn về bảo mật, tăng cường bảo mật trong giao tiếp và truyền dữ liệu giữa các thiết bị. Điều này sẽ góp phần truyền và bảo vệ thông tin nhạy cảm một cách an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tích hợp với Trí tuệ nhân tạo',
      desc: 'LoRa được dự đoán sẽ tích hợp với Trí tuệ nhân tạo (AI) để tăng cường quy trình phân tích dữ liệu và ra quyết định, từ đó cung cấp các giải pháp đổi mới hơn nữa trong nhiều lĩnh vực khác nhau như phân tích dự đoán, công nghệ tự lái.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingAsset.thumb,
        data: 'manufacturingAsset',
        link: '/vi/enterprise/manufacturing/asset',
      },
    ],
  },
};
